

const Header = ({ title }) => {
  return (
    <header className="Header">
      <h1>
        {title}
      </h1>
    </header>
  );
};

Header.defaultProps = {
  title: "Blogiverse",
};

export default Header;
